export const scopes = '';
export const accessToken = '';